<template>
    <div class="fill-height d-flex">

        <v-expand-x-transition>
            <div class="px-2 fill-height of-y flex-grow-1 flex-equal" style="max-width: 45%">
                <template v-for="device in filteredDevices">
                    <div class="pa-2">
                        <v-card
                                class="d-flex align-center"
                                :key="device._id"
                                @click.self="$store.state.ref.devices.selected = $store.state.ref.devices.selected === device ? null : device"
                                :raised="$store.state.ref.devices.selected === device"
                                hover
                        >
                            <div class="ml-2" @click.self="$store.state.ref.devices.selected = $store.state.ref.devices.selected === device ? null : device">
                                <template v-if="$store.state.ref.devices.selected === device">
                                    <v-icon color="primary">mdi-check-circle</v-icon>
                                </template>
                                <template v-else>
                                    <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                                </template>
                            </div>

                            <div class="subtitle-1 font-weight-light flex-grow-1 flex-equal pa-2 text-truncate" @click.self="$store.state.ref.devices.selected = $store.state.ref.devices.selected === device ? null : device">
                                {{device.name}}
                            </div>

                            <div class="d-flex align-center pr-2" v-if="device.employeeId && employeesRef[device.employeeId]">
                                <v-tooltip top :disabled="!employeesRef[device.employeeId].disabled">
                                    <template v-slot:activator="{on}" >
                                        <div v-on="on" @click.stop="access.setup ? gotoEmployeeSettings(device.employeeId) : () => {}">
                                            <app-outlined-chip
                                                    @click.stop="access.setup ? gotoEmployeeSettings(device.employeeId) : () => {}"
                                                    :label="employeesRef[device.employeeId].name"
                                                    :icon="employeesRef[device.employeeId].disabled ? 'mdi-account-lock' : 'mdi-account'"
                                                    :color="employeesRef[device.employeeId].disabled ? 'grey' : 'primary'"
                                            />
                                        </div>

                                    </template>
                                    Employee Disabled
                                </v-tooltip>
                            </div>

                            <div v-if="device.phone" class="d-flex align-center pr-2">
                                <v-tooltip
                                        top
                                >
                                    <template v-slot:activator="{on}">
                                        <v-icon color="grey darken-2" v-on="on" class="pr-2">mdi-phone</v-icon>
                                    </template>
                                    Phone Extension
                                </v-tooltip>
                            </div>
                          
                          <div v-if="device.o365TenantUser" class="d-flex align-center pr-2">
                            <v-tooltip
                                top
                            >
                              <template v-slot:activator="{on}">
                                <img v-on="on" src="@/assets/teams.svg" class="pr-2" height="24px">
                              </template>
                              Microsoft Teams User
                            </v-tooltip>
                          </div>

                            <div class="d-flex align-center pr-2" v-if="!device.phone && !device.o365TenantUser && !latestVersionsLoading && latestVersions && latestVersions.appVersion && latestVersions.launcherVersion && latestVersions.updateVersion">
                                <v-tooltip
                                        top
                                        v-if="!device.appVersion || !device.launcherVersion || !device.updateVersion"
                                >
                                    <template v-slot:activator="{on}">
                                        <v-icon color="amber" v-on="on" class="pr-2">mdi-alert-outline</v-icon>
                                    </template>
                                    No version info
                                </v-tooltip>
                                <v-tooltip
                                        top
                                        v-else-if="vToInt(latestVersions.appVersion) > vToInt(device.appVersion) || vToInt(latestVersions.launcherVersion) > vToInt(device.launcherVersion) || vToInt(latestVersions.updateVersion) > vToInt(device.updateVersion)"
                                >
                                    <template v-slot:activator="{on}">
                                        <v-icon color="error" v-on="on" class="pr-2">mdi-alert-outline</v-icon>
                                    </template>
                                    Agent out of date
                                </v-tooltip>
                                <v-tooltip
                                        top
                                        v-else
                                >
                                    <template v-slot:activator="{on}">
                                        <v-icon color="green" v-on="on" class="pr-2">mdi-check</v-icon>
                                    </template>
                                    Agent up to date
                                </v-tooltip>
                            </div>

<!--                            TODO Add After Cert-->

<!--                            <div class="d-flex align-center pr-2" v-if="!device.phone">-->
<!--                                <v-tooltip-->
<!--                                        top-->
<!--                                        v-if="onlineDeviceIds.includes(device._id)"-->
<!--                                >-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-icon color="green" v-on="on" class="pr-2">mdi-lan-connect</v-icon>-->
<!--                                    </template>-->
<!--                                    Device Online-->
<!--                                </v-tooltip>-->
<!--                                <v-tooltip-->
<!--                                        top-->
<!--                                        v-else-->
<!--                                >-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-icon color="error" v-on="on" class="pr-2">mdi-lan-disconnect</v-icon>-->
<!--                                    </template>-->
<!--                                    Device Offline-->
<!--&lt;!&ndash;                                    {{!!realTimeByDeviceId[device._id] ? ` - Last Active: ${format(new Date(realTimeByDeviceId[device._id].lastActive), dateFormats.longDate)}` : null}}&ndash;&gt;-->
<!--                                </v-tooltip>-->
<!--&lt;!&ndash;                                <v-tooltip&ndash;&gt;-->
<!--&lt;!&ndash;                                        top&ndash;&gt;-->
<!--&lt;!&ndash;                                        v-else-if="vToInt(latestVersions.appVersion) > vToInt(device.appVersion) || vToInt(latestVersions.launcherVersion) > vToInt(device.launcherVersion) || vToInt(latestVersions.updateVersion) > vToInt(device.updateVersion)"&ndash;&gt;-->
<!--&lt;!&ndash;                                >&ndash;&gt;-->
<!--&lt;!&ndash;                                    <template v-slot:activator="{on}">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <v-icon color="error" v-on="on" class="pr-2">mdi-alert-outline</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </template>&ndash;&gt;-->
<!--&lt;!&ndash;                                    Agent out of date&ndash;&gt;-->
<!--&lt;!&ndash;                                </v-tooltip>&ndash;&gt;-->
<!--&lt;!&ndash;                                <v-tooltip&ndash;&gt;-->
<!--&lt;!&ndash;                                        top&ndash;&gt;-->
<!--&lt;!&ndash;                                        v-else&ndash;&gt;-->
<!--&lt;!&ndash;                                >&ndash;&gt;-->
<!--&lt;!&ndash;                                    <template v-slot:activator="{on}">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <v-icon color="green" v-on="on" class="pr-2">mdi-check</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </template>&ndash;&gt;-->
<!--&lt;!&ndash;                                    Agent up to date&ndash;&gt;-->
<!--&lt;!&ndash;                                </v-tooltip>&ndash;&gt;-->
<!--                            </div>-->

<!--                            <v-speed-dial-->
<!--                                    class="pa-0 ma-0 mr-3"-->
<!--                                    direction="left"-->
<!--                                    open-on-hover-->
<!--                            >-->
<!--                                <template v-slot:activator>-->
<!--                                    <v-btn-->
<!--                                            color="primary"-->
<!--                                            dark-->
<!--                                            small-->
<!--                                            icon-->
<!--                                    >-->
<!--                                        <v-icon>-->
<!--                                            mdi-cog-->
<!--                                        </v-icon>-->
<!--                                    </v-btn>-->
<!--                                </template>-->

<!--                                <v-tooltip top>-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-btn-->
<!--                                                class="indigo"-->
<!--                                                color="white"-->
<!--                                                icon-->
<!--                                                v-on="on"-->
<!--                                                @click="(event) => {-->
<!--                                                    event.preventDefault()-->
<!--                                                    $store.state.ref.devices.selected = device-->
<!--                                                    $nextTick(() => {-->
<!--                                                        $refs.sidebar.showTransferOwnership = true;-->
<!--                                                    })-->
<!--                                                }"-->
<!--                                        >-->
<!--                                            <v-icon>mdi-swap-horizontal</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    Transfer Ownership-->
<!--                                </v-tooltip>-->

<!--                                <v-tooltip top>-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-btn-->
<!--                                                class="green"-->
<!--                                                color="white"-->
<!--                                                icon-->
<!--                                                v-on="on"-->
<!--                                                @click="-->
<!--                                                (event) => {-->
<!--                                                    event.preventDefault()-->
<!--                                                    $store.state.ref.devices.selected = device-->
<!--                                                    $nextTick(() => {-->
<!--                                                        $refs.sidebar.showRenameDevice = true;-->
<!--                                                    })-->
<!--                                                }"-->
<!--                                        >-->
<!--                                            <v-icon>mdi-pencil</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    Rename Device-->
<!--                                </v-tooltip>-->

<!--                                <v-tooltip top>-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-btn-->
<!--                                                class="red"-->
<!--                                                color="white"-->
<!--                                                icon-->
<!--                                                v-on="on"-->
<!--                                                @click="(event) => {-->
<!--                                                    event.preventDefault()-->
<!--                                                    $store.state.ref.devices.selected = device-->
<!--                                                    $nextTick(() => {-->
<!--                                                        $refs.sidebar.showDisableDevice = true-->
<!--                                                    })-->
<!--                                                }"-->
<!--                                        >-->
<!--                                            <v-icon>{{device.disabled ? 'mdi-lock-off' : 'mdi-lock'}}</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    {{ device.disabled ? 'Enable Device' : 'Disable Device' }}-->
<!--                                </v-tooltip>-->
<!--                            </v-speed-dial>-->

                        </v-card>
                    </div>
                </template>
            </div>
        </v-expand-x-transition>


        <v-slide-x-reverse-transition>
            <div v-if="selectedDevice" class="fill-height" style="width: 55%">
                <app-device-side-bar
                        :selected-device="selectedDevice"
                        ref="sidebar"
                        @checkSelected="checkSelectedDeviceTab"
                />
            </div>
        </v-slide-x-reverse-transition>



<!--        <div style="width: 300px" class="flex-shrink-0 white-back d-flex">-->
<!--            <app-list-->
<!--                    class="flex-grow-1"-->
<!--                    @input="con.log('INPUT', $event)"-->
<!--                    v-model="$store.state.ref.devices.selected"-->
<!--                    :items="devices"-->
<!--                    :multiple="false"-->
<!--                    headline-key="name"-->
<!--                    sub-line-key="hardwareDescription"-->
<!--                    item-key="_id"-->
<!--                    :show-check-boxes="true"-->
<!--                    :return-object="true"-->
<!--            >-->
<!--            </app-list>-->
<!--            <v-divider vertical></v-divider>-->
<!--        </div>-->
<!--        <div class="flex-grow-1 pa-2">-->
<!--            {{$store.state.ref.devices.selected}}-->
<!--        </div>-->
    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import AppList from "@/components/Shared/AppList/AppList";
import AppUserCreate from "@/components/Users/AppUserCreate";
import AppUserModify from "@/components/Users/AppUserModify";
import AppDeviceSideBar from "@/components/Devices/AppDeviceSideBar";
import AppOutlinedChip from "@/components/Shared/AppOutlinedChip";
import {dateFormats, nameSort} from "@/core/codeFunctions";
import {format} from "date-fns";

export default {
    components: {AppOutlinedChip, AppDeviceSideBar, AppUserModify, AppUserCreate, AppList},
    data() {
        return {
            format,
            dateFormats,
            con: console,
            showAddUser: false,
            userChanged: false,
            latestVersions: null,
            latestVersionsLoading: false,
            vToInt: (value) => {
                const splits = value.split('.')
                while (splits.length < 3)
                    splits.unshift('0')
                splits.forEach((val, i) => {
                    const padAmm = (2 - i)
                    splits[i] = val.padStart(3, '0')
                    for (let k = i; k < padAmm; ++k)
                        splits[i] = splits[i].padEnd(padAmm, '0')
                })
                const val = +splits.reduce((amm, v) => amm + v, 0)
                return val
            }
        }
    },
    watch: {
        "$store.state.ref.users.selected"() {
            this.userChanged = true;
            this.$nextTick(() => {
                this.userChanged = false;
            })
        },
        "$store.state.ref.devices.tabIndex"() {
            this.checkSelectedDeviceTab()
        }
    },
    created() {
        this.devices.on('deleted', this.deselectDeleted)
    },
    beforeUnmount() {
        this.devices.off('deleted', this.deselectDeleted)
    },
    mounted() {
        this.checkSelectedDeviceTab();
        this.getLatestVersions();
    },
    methods: {
        ...mapActions(['gotoEmployeeSettings']),

        async getLatestVersions() {
            try {
                this.latestVersionsLoading = true;
                this.latestVersions = await this.$newReq('GET', 'latestVersions')
            } catch (e) {
                console.log(e)
            } finally {
                this.latestVersionsLoading = false;
            }
        },

        checkSelectedDeviceTab() {
            if (!this.selectedDevice)
                return
            const hasEmployee = !!this.selectedDevice.employeeId
            const employeeDisabled = hasEmployee ? this.employeesRef[this.selectedDevice.employeeId].disabled : null
            const deviceDisabled = this.selectedDevice.disabled

            switch (this.$store.state.ref.devices.tabIndex) {
                case 0 : if (!hasEmployee || employeeDisabled || deviceDisabled)
                    return this.$store.state.ref.devices.selected = null;
                else break
                case 1 : {

                    if (!deviceDisabled) {
                        if (hasEmployee) {
                            if (!employeeDisabled) {
                                return this.$store.state.ref.devices.selected = null;
                            }
                        } else {
                            return this.$store.state.ref.devices.selected = null;
                        }
                    }
                    break;

                    // if (!hasEmployee || (!employeeDisabled && !deviceDisabled))
                    //     return this.$store.state.ref.devices.selected = null;
                    // else break
                }
                case 2 : if (hasEmployee || deviceDisabled || (hasEmployee && employeeDisabled))
                    return this.$store.state.ref.devices.selected = null;
                else break
            }
        },
        selectDevice(device) {
            this.$store.state.ref.devices.selected = device
        },
        deselectDeleted(delObj) {
            if (this.$store.state.ref.devices.selected === delObj)
                this.$store.state.ref.devices.selected = null
        }
    },
    computed: {
        ...mapGetters(['devices', 'employeesRef', 'devicesWithAccess', 'access', 'realTimeByDeviceId', 'onlineDeviceIds']),
        selectedDevice() {
            return this.$store.state.ref.devices.selected
        },
        filteredDevices() {
            return this.devicesWithAccess.filter((device) => {
                const hasEmployee = !!device.employeeId
                const employeeDisabled = hasEmployee ? this.employeesRef[device.employeeId].disabled : null
                const deviceDisabled = device.disabled

                switch (this.$store.state.ref.devices.tabIndex) {
                    case 0 : if (!hasEmployee || employeeDisabled || deviceDisabled)
                        return false
                    else break
                    case 1 : {
                        if (!deviceDisabled) {
                            if (hasEmployee) {
                                if (!employeeDisabled) {
                                    return false
                                }
                            } else {
                                return false
                            }
                        }
                        break;
                    }
                    case 2 : if (hasEmployee || deviceDisabled || (hasEmployee && employeeDisabled))
                        return false
                    else break
                }

                return this.$store.state.ref.devices.filterStr ? (JSON.stringify(device) + (device.employeeId ? this.employeesRef[device.employeeId].name : "")).toLowerCase().includes((this.$store.state.ref.devices.filterStr || '').toLowerCase()) : true

            })
            .sort((a,b) => {
                if ((a.employeeId ? this.employeesRef[a.employeeId].name : "") === (b.employeeId ? this.employeesRef[b.employeeId].name : ""))
                    return a.name > b.name ? 1 : -1;
                else
                    return (a.employeeId ? this.employeesRef[a.employeeId].name : "") > (b.employeeId ? this.employeesRef[b.employeeId].name : "") ? 1 : -1
                }
            )
        },
    },
}
</script>

<style scoped>

</style>